/**
 * useEditorHandoff — the minimal routing/state bridge into the existing
 * editor. This is the ONLY place the generator reaches outside its own
 * module, and it does so through the editor's existing, unmodified loading
 * contract: navigate to `/editor` with `location.state.template` shaped
 * exactly like any template the editor already loads
 * (`{ name, canvas_width, canvas_height, template_json: { pages } }`).
 *
 * There is no `:id` in the route, so the editor loads purely from state and
 * performs no API fetch and no format conversion — the compiled Editor
 * Document IS the native template_json. The editor stays completely unaware
 * that a deterministic pipeline produced it.
 */
import { useNavigate } from 'react-router-dom';

export const useEditorHandoff = () => {
  const navigate = useNavigate();

  /** Open a compiled result's Editor Document in the live editor. */
  const openInEditor = (card) => {
    if (!card?.editorDocument) return;
    const doc = card.editorDocument;
    navigate('/editor', {
      state: {
        template: {
          name: card.name,
          canvas_width: doc.canvas_width,
          canvas_height: doc.canvas_height,
          template_json: {
            canvas_width: doc.canvas_width,
            canvas_height: doc.canvas_height,
            pages: doc.pages,
          },
        },
      },
    });
  };

  return { openInEditor };
};
